import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  IAppErrorFactory,
  ICompanyReferencesService,
  IUpdateCompanyReferenceUseCase,
  UpdateCompanyReferenceUseCaseInput,
  UpdateCompanyReferenceUseCaseOutput,
} from '../../types'

@injectable()
export default class UpdateCompanyReferenceInteractor implements IUpdateCompanyReferenceUseCase {
  @inject(symbols.ICompanyReferencesService) private companyReferencesService: ICompanyReferencesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdateCompanyReferenceUseCaseInput): Promise<UpdateCompanyReferenceUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.companyReference = await this.companyReferencesService.updateCompanyReference(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: 'リファレンスの更新に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdateCompanyReferenceUseCaseOutput {
    return {
      companyReference: null,
      error: null,
    }
  }
}
